<script lang="ts">
	import { settings, playingNotificationSound, isLastActiveTab } from '$lib/stores';
	import DOMPurify from 'dompurify';

	import { marked } from 'marked';
	import { createEventDispatcher, onMount } from 'svelte';

	const dispatch = createEventDispatcher();

	export let onClick: Function = () => {};
	export let title: string = '';
	export let content: string;

	onMount(() => {
		if (!navigator.userActivation.hasBeenActive) {
			return;
		}

		if (!$playingNotificationSound && $isLastActiveTab) {
			playingNotificationSound.set(true);

			const audio = new Audio(`/audio/notification.mp3`);
			audio.play().finally(() => {
				// Ensure the global state is reset after the sound finishes
				playingNotificationSound.set(false);
			});
		}
	});
</script>

<button
	class="flex gap-2.5 text-left min-w-[var(--width)] w-full bg-[var(--success-bg)] text-[var(--success-text)] border border-[var(--success-border)] rounded-lg p-4 text-[13px]"
	on:click={() => {
		onClick();
		dispatch('closeToast');
	}}
>
	<div>
		{#if title}
			<div class=" text-[13px] font-medium mb-0.5 line-clamp-1 capitalize">{title}</div>
		{/if}

		<div class=" line-clamp-2 self-center font-normal">
			{@html DOMPurify.sanitize(marked(content))}
		</div>
	</div>
</button>
